/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AuditLogCreateRequest {
    getFixupPrototypeFunction() { return AuditLogCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<AuditLogCreateRequest>): AuditLogCreateRequest {
        let obj = Object.assign(new AuditLogCreateRequest(), model);
        AuditLogCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AuditLogCreateRequest>): AuditLogCreateRequest {
        if (!model) return null;
        return AuditLogCreateRequest.newInstance(<AuditLogCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AuditLogCreateRequest) {
        if (!obj) return;

        models.AuditLogCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AuditLogCreateRequest): boolean {
        Object.setPrototypeOf(obj, AuditLogCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of the event performed.
     */
    event_type: models.AuditLogEventType;

    /**
     * Type of the action performed.
     */
    event_action: models.AuditLogEventAction;

    /**
     * The id of the account master within the CoreStack.
     */
    master_account_id: string;

    /**
     * The name of the account master within the CoreStack.
     */
    master_account_name: string;

    /**
     * The name of the tenant within the CoreStack account.
     */
    tenant_name: string;

    /**
     * The name of the user who performed the action.
     */
    user_name: string;

    /**
     * IP from which the action is performed.
     */
    source_ip_address: string;

    /**
     * Description for the action done by user.
     */
    activity: string;

}
